import { render, staticRenderFns } from "./RemoveButton.vue?vue&type=template&id=d1b410c4&scoped=true"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"
import style0 from "./RemoveButton.vue?vue&type=style&index=0&id=d1b410c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b410c4",
  null
  
)

export default component.exports